import { Modal, ModalBody, ModalHeader, Typography, } from '@one-thd/sui-atomic-components';
import React from 'react';
import { useCommonContext } from '../../../hooks/useContexts';
import { getProviderImage } from '../../../utils/order-details/trackingProvider';
import TrackShipmentDetails from './TrackShipmentDetails';
export var TrackShipmentModal = function (_a) {
    var modalOpen = _a.modalOpen, handleModalClose = _a.handleModalClose, shipmentTrackingDetail = _a.shipmentTrackingDetail;
    var isMobile = useCommonContext().isMobile;
    var mobileSize = isMobile ? 'lg' : 'md';
    var shippingProviderLogo = shipmentTrackingDetail
        ? getProviderImage(shipmentTrackingDetail.providerCode)
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: modalOpen, onClose: handleModalClose, size: mobileSize },
            React.createElement(ModalHeader, { onClose: handleModalClose },
                React.createElement("div", { className: "sui-flex sui-gap-4" },
                    shippingProviderLogo,
                    React.createElement(Typography, { variant: "h4", weight: "display" }, "Package Tracking"))),
            React.createElement("hr", null),
            React.createElement(ModalBody, null,
                React.createElement(TrackShipmentDetails, { shipmentTrackingDetail: shipmentTrackingDetail })))));
};
export default TrackShipmentModal;
